import { render, staticRenderFns } from "./dodajbota.vue?vue&type=template&id=d3949612&"
import script from "./dodajbota.vue?vue&type=script&lang=js&"
export * from "./dodajbota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports